import React, { Component } from 'react';
import { VerificationForm } from '@sheerid/jslib';
import '@sheerid/jslib/sheerid.css';
import './App.css';

import { programId } from './programOptions';

class App extends Component {
    render() {
        return (
            <div className="sid-verification-wrapper">
                <div className="sid-headband">
                        <div>
                            <img className="sid-headband__logo" src="./logo.png" alt="pvolve logo"/>
                        </div>
                </div>
                <div className="sid-verification-wrapper__columns">
                    <div className="sid-verification-wrapper__form sid-verification-wrapper__column">
                        <VerificationForm programId={programId} />
                    </div>
                    <div className="sid-verification-wrapper__column-right sid-verification-wrapper__column sid-l-space-top-lg">
                        <img src="./medical.jpg" alt="personal info photo" className="sid-right-image" />
                    </div>
                </div>
            </div>
        );
    }
}

export default App;
